import Container from "./container";
/**
 * @module Pagination
 * @description 分頁用工具
 */
export default Container;